
(function() {
  function initDwPicker() {
    var pickers = document.querySelectorAll('.dw-picker');
    var isMobile = function() { return window.innerWidth < 750; };

    // ★ v5.5 : si "En stock" ne rentre pas sur le trigger -> on ne garde que le point vert
    function fitTriggerStock(picker) {
      var stk = picker.querySelector('.dw-picker__trigger .dw-picker__stk');
      if (!stk) return;
      stk.style.display = '';
      requestAnimationFrame(function() {
        stk.style.display = (stk.scrollWidth > stk.clientWidth + 1) ? 'none' : '';
      });
    }

    pickers.forEach(function(picker) {
      var trigger = picker.querySelector('.dw-picker__trigger');
      var panel = picker.querySelector('.dw-picker__panel');
      var scroll = panel.querySelector('.dw-picker__scroll');
      var backdrop = picker.querySelector('.dw-picker__backdrop');
      var closeBtn = panel.querySelector('.dw-picker__sheet-close');
      var hint = panel.querySelector('.dw-picker__hint');
      var rows = panel.querySelectorAll('.dw-picker__row');
      var sectionId = picker.id.replace('dw-picker-', '');
      var focusIndex = -1;
      var touchStartY = 0;
      var touchDeltaY = 0;

      var savedScrollY = 0;
      /* ★ C1 vague 4 (point 1) : on retient si le verrou a REELLEMENT ete
         pose. Sans ce drapeau, `unlockScroll()` s'executait en pastilles a plat
         (ou `open()` n'est jamais appele, donc `lockScroll()` non plus) et
         `window.scrollTo(0, savedScrollY)` renvoyait la page a savedScrollY = 0,
         c'est-a-dire tout en haut. C'etait la cause du saut mobile au
         changement de taille : mesure du 21/08, y = 674 avant le tap, y = 0
         apres, avec `unlockScroll` dans la pile. */
      var scrollLocked = false;

      function lockScroll() {
        if (scrollLocked) return;
        savedScrollY = window.scrollY;
        scrollLocked = true;
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + savedScrollY + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.overflow = 'hidden';
      }

      function unlockScroll() {
        if (!scrollLocked) return;
        scrollLocked = false;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.overflow = '';
        window.scrollTo(0, savedScrollY);
      }

      function open() {
        document.querySelectorAll('.dw-picker.is-open').forEach(function(p) {
          p.classList.remove('is-open');
        });
        picker.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');

        if (isMobile()) {
          lockScroll();
        }

        requestAnimationFrame(function() {
          checkHint();
          var activeRow = panel.querySelector('.dw-picker__row--active');
          /* ★ C1 vague 3 (A1/A3) : plus de scrollIntoView.
             `scrollIntoView` remonte TOUS les conteneurs defilables jusqu'a la
             fenetre, pas seulement le panneau. Depuis que le panneau s'ouvre
             d'un seul tenant (plus d'ascenseur interne, C1 vague 1), il n'avait
             donc plus rien a faire d'autre que faire sauter la page : mesure du
             21/08 sur la preview, y = 700 avant le clic sur le declencheur,
             y = 350 apres. On centre la ligne active DANS le conteneur, a la
             main, et uniquement s'il defile vraiment. */
          if (isMobile()) {
            scroll.scrollTop = 0;
          } else if (activeRow && scroll.scrollHeight > scroll.clientHeight + 1) {
            scroll.scrollTop = Math.max(
              0,
              activeRow.offsetTop - scroll.clientHeight / 2 + activeRow.offsetHeight / 2
            );
          }
          if (activeRow) {
            focusIndex = Array.from(rows).indexOf(activeRow);
          }
        });
      }

      function close() {
        /* ★ C1 vague 4 (point 1) : en pastilles a plat, `selectRow()` appelait
           quand meme `close()` 200 ms apres le clic. Il n'y a rien a fermer :
           on sort, et surtout on ne touche ni au focus ni au defilement. */
        if (!picker.classList.contains('is-open')) {
          focusIndex = -1;
          return;
        }
        picker.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        unlockScroll();
        panel.style.transform = '';
        focusIndex = -1;
        /* ★ C1 vague 3 (A1) : `preventScroll`. En pastilles a plat le
           declencheur est masque, le focus y est sans effet ; dans le tiroir il
           est visible, et le navigateur le ramenait dans la fenetre : un
           deuxieme saut, apres celui de l'ouverture. */
        try {
          trigger.focus({ preventScroll: true });
        } catch (e) {
          trigger.focus();
        }
      }

      function selectRow(row) {
        var sizeValue = row.getAttribute('data-size-value');
        var priceText = row.getAttribute('data-price');
        var comparePrice = row.getAttribute('data-compare-price');
        var discount = parseInt(row.getAttribute('data-discount'), 10) || 0;
        var isAvailable = row.getAttribute('data-available') === 'true';

        rows.forEach(function(r) {
          r.classList.remove('dw-picker__row--active');
          r.setAttribute(r.getAttribute('role') === 'radio' ? 'aria-checked' : 'aria-selected', 'false');
        });
        row.classList.add('dw-picker__row--active');
        row.setAttribute(row.getAttribute('role') === 'radio' ? 'aria-checked' : 'aria-selected', 'true');

        document.getElementById('dw-dim-' + sectionId).textContent = sizeValue;

        var priceEl = document.getElementById('dw-price-' + sectionId);
        var compareEl = document.getElementById('dw-compare-' + sectionId);

        priceEl.textContent = priceText;

        if (discount >= 1) {
          priceEl.classList.add('dw-picker__trigger-price--sale');
          if (compareEl) {
            compareEl.textContent = comparePrice;
            compareEl.removeAttribute('hidden');
          }
        } else {
          priceEl.classList.remove('dw-picker__trigger-price--sale');
          if (compareEl) compareEl.setAttribute('hidden', '');
        }

        var dotEl = document.getElementById('dw-dot-' + sectionId);
        var stkEl = document.getElementById('dw-stk-' + sectionId);

        if (isAvailable) {
          dotEl.className = 'dw-picker__mid dw-picker__mid--in';
          stkEl.className = 'dw-picker__stk dw-picker__stk--in';
          stkEl.textContent = 'En stock';
        } else {
          dotEl.className = 'dw-picker__mid dw-picker__mid--out';
          stkEl.className = 'dw-picker__stk dw-picker__stk--out';
          stkEl.textContent = 'Épuisé';
        }

        var variantSelects = document.getElementById('variant-selects-' + sectionId);
        if (variantSelects) {
          var radios = variantSelects.querySelectorAll('input[type="radio"]');
          radios.forEach(function(radio) {
            if (radio.value.trim() === sizeValue.trim()) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }

        fitTriggerStock(picker); /* ★ v5.5 : recalcule l'affichage "En stock" / point seul */

        setTimeout(close, 200);
      }

      function checkHint() {
        if (!hint) return;
        var scrollable = scroll.scrollHeight > scroll.clientHeight + 10;
        var atBottom = scroll.scrollHeight - scroll.scrollTop - scroll.clientHeight < 10;

        if (scrollable && !atBottom) {
          hint.classList.add('is-visible');
          hint.classList.remove('is-hidden');
        } else {
          hint.classList.remove('is-visible');
          hint.classList.add('is-hidden');
        }
      }

      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        if (picker.classList.contains('is-open')) {
          close();
        } else {
          open();
        }
      });

      if (backdrop) {
        backdrop.addEventListener('click', close);
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', close);
      }

      rows.forEach(function(row) {
        row.addEventListener('click', function() {
          selectRow(this);
        });
      });

      scroll.addEventListener('scroll', checkHint, { passive: true });

      panel.addEventListener('keydown', function(e) {
        var key = e.key;

        if (key === 'Escape') {
          e.preventDefault();
          close();
          return;
        }

        if (key === 'ArrowDown' || key === 'ArrowUp') {
          e.preventDefault();
          var dir = key === 'ArrowDown' ? 1 : -1;
          focusIndex = Math.max(0, Math.min(rows.length - 1, focusIndex + dir));
          rows[focusIndex].focus();
          rows[focusIndex].scrollIntoView({ block: 'nearest' });
          return;
        }

        if (key === 'Enter' && focusIndex >= 0) {
          e.preventDefault();
          selectRow(rows[focusIndex]);
        }
      });

      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
          if (!picker.classList.contains('is-open')) {
            e.preventDefault();
            open();
            setTimeout(function() { panel.focus(); }, 100);
          }
        }
      });

      var sheetHeader = panel.querySelector('.dw-picker__sheet-header');
      if (sheetHeader) {
        sheetHeader.addEventListener('touchstart', function(e) {
          touchStartY = e.touches[0].clientY;
          touchDeltaY = 0;
          panel.style.transition = 'none';
        }, { passive: true });

        sheetHeader.addEventListener('touchmove', function(e) {
          touchDeltaY = e.touches[0].clientY - touchStartY;
          if (touchDeltaY > 0) {
            panel.style.transform = 'translateY(' + touchDeltaY + 'px)';
          }
        }, { passive: true });

        sheetHeader.addEventListener('touchend', function() {
          panel.style.transition = '';
          if (touchDeltaY > 80) {
            close();
          } else {
            panel.style.transform = '';
          }
        });
      }

      fitTriggerStock(picker); /* ★ v5.5 : état initial */
      window.addEventListener('resize', function() { fitTriggerStock(picker); }); /* ★ v5.5 */
    });

    /* ★ C1 vague 3 (A3) : le tiroir se ferme au clic n'importe ou en dehors ET
       a Echap.
       Avant, Echap n'etait ecoute que sur le panneau : il ne fonctionnait donc
       que si le tiroir avait ete ouvert au clavier (c'est la seule branche qui
       donne le focus au panneau). Ouvert a la souris, la touche ne faisait
       rien. L'ecoute passe au document, ou elle marche dans les deux cas. */
    function closeAllOpen() {
      var open = document.querySelectorAll('.dw-picker.is-open');
      if (!open.length) return false;
      open.forEach(function(p) {
        p.classList.remove('is-open');
        var t = p.querySelector('.dw-picker__trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (document.body.style.position === 'fixed') {
        var scrollY = parseInt(document.body.style.top || '0', 10) * -1;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.overflow = '';
        window.scrollTo(0, scrollY);
      }
      return true;
    }

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.dw-picker')) closeAllOpen();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (closeAllOpen()) e.preventDefault();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDwPicker);
  } else {
    initDwPicker();
  }
})();
